import { env } from '../../../shared/config/env';
import { buildPublicPageTargets } from './publicPages';

function joinUrl(baseUrl: string, path: string) {
  return `${baseUrl.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
}

export type AuthLinkMode = 'signIn' | 'signUp';

export const links = {
  site: env.siteUrl,
  playground: env.playgroundUrl,
  forum: env.forumUrl,

  create: joinUrl(env.playgroundUrl, '/projects/editor'),
  myStuff: joinUrl(env.playgroundUrl, '/mystuff'),
  signIn: joinUrl(env.playgroundUrl, '/sign-in'),
  signUp: joinUrl(env.playgroundUrl, '/sign-up'),
  tutorials: joinUrl(env.playgroundUrl, '/tutorials'),
  explore: joinUrl(env.playgroundUrl, '/explore'),
  about: joinUrl(env.playgroundUrl, '/about'),
  contact: joinUrl(env.playgroundUrl, '/contact'),
  policy: joinUrl(env.playgroundUrl, '/privacy-policy'),
  terms: joinUrl(env.playgroundUrl, '/term'),
  olympic: joinUrl(env.playgroundUrl, '/olympic'),
  footer: {
    aboutUs: joinUrl(env.playgroundUrl, '/about'),
    joinUs: joinUrl(env.playgroundUrl, '/contact'),
    privacyPolicy: joinUrl(env.playgroundUrl, '/privacy-policy'),
    terms: joinUrl(env.playgroundUrl, '/term'),
    forum: env.forumUrl,
  },
} as const;

export const publicPageTargets = buildPublicPageTargets({ playgroundUrl: env.playgroundUrl });

export const primaryNavTargets = publicPageTargets.filter((target) => target.includeInNav);

export const footerHighlightTargets = publicPageTargets.filter((target) => target.includeInFooterHighlight);

export function getAuthLink(mode: AuthLinkMode) {
  return mode === 'signUp' ? links.signUp : links.signIn;
}
